import { ToothSvgComponentProps } from '@/modules/patientList/patientStrip/patientStripOdontogram/types';

const SvgNormal = (props: ToothSvgComponentProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18 * (props.wx ?? 1)}
    height={27 * (props.hx ?? 1)}
    viewBox="0 0 18 27"
    fill="none"
    className={props.className}
  >
    <path
      fill={props.fill || '#E4E4E7'}
      stroke={props.stroke || '#A1A1AA'}
      strokeLinejoin="round"
      d="M8.783 1.805c-1.333 0-4.8-1.923-6.801.176-1.605 1.683-1.012 5.73.137 8.454.428 1.013.41 2.269.324 3.443-.344 4.702 1.19 11.94 2.593 11.856 1.437-.088 1.309-8.708 3.48-9.46 1.267-.439 1.563 1.821 1.844 3.938.337 2.532.139 5.176.854 5.448.833.315 2.414-1.805 3.254-5.656.45-2.07.645-4.408.588-6.097-.037-1.094-.038-2.459.39-3.472 1.15-2.723 1.742-6.77.138-8.453-2.003-2.1-5.469-.177-6.802-.177Z"
    />
  </svg>
);
export default SvgNormal;
